import BookingData from "./BookingData";

export default BookingData;
